import { AppleAuthService } from './apple-auth/apple-auth.service';
import { GoogleAuthService } from './google-auth/google-auth.service';

export { AppleAuthService, GoogleAuthService };

export default [AppleAuthService, GoogleAuthService];
